import React from "react";
import './login.css';
import { Button, Col, Form, Input, Layout, message, Row } from "antd";
import { Content } from "antd/lib/layout/layout";
import mainLogo from "./components/common/main-logo";
import { observer } from 'mobx-react';
import { useStore } from "./stores/root-store";

type FieldType = {
    login: string;
    password: string;
    remember: string;
};

const LoginPage: React.FC = () => {

    const { authStore } = useStore()

    const onFinish = (values: FieldType) => {
        authStore.login(values.login, values.password);
    }

    const onFinishFailed = (errorInfo: any) => {
        message.error("Ошибка входа в систему!");
        console.log(errorInfo);
    }

    return (
        <Layout className="login__page">
            <Content>
                <Row className="login__page_top"></Row>
                <Row justify="space-around" align="middle">
                    <Col span={6}>
                        <Form
                            name="basic"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValues={{ remember: true }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                            className="login__page_form"
                        >
                            <div className="login__logo"><mainLogo.dark /></div>
                            <Form.Item<FieldType>
                                label="Логин"
                                name="login"
                                rules={[{ required: true, message: 'Пожалуйста, введите логин!' }]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item<FieldType>
                                label="Пароль"
                                name="password"
                                rules={[{ required: true, message: 'Пожалуйста, введите пароль!' }]}
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                                <Button type="primary" htmlType="submit">
                                    Войти
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
};

export default observer(LoginPage);